import { useEffect, useState } from "react";
import { api } from "../../../shared/api/client";
import { Pill } from "../../../shared/components/Pill";

type Health = { status: string; redis?: boolean };

export function AdminHealth() {
  const [data, setData] = useState<Health | null>(null);
  useEffect(() => { api.get<Health>("/admin/system/health").then((r) => setData(r.data)).catch(() => setData({ status: "unreachable" })); }, []);
  return (
    <div className="t-grid cols-1">
      <div className="t-card">
        <h3 style={{ margin: "0 0 12px" }}>시스템 상태</h3>
        <div className="t-list">
          <div className="t-row">
            <span style={{ flex: 1 }}>API</span>
            <Pill kind={data?.status === "ok" ? "ok" : "warn"}>{data?.status ?? "—"}</Pill>
          </div>
          <div className="t-row">
            <span style={{ flex: 1 }}>Redis</span>
            <Pill kind={data?.redis ? "ok" : "muted"}>{data?.redis ? "연결됨" : "미연결"}</Pill>
          </div>
        </div>
      </div>
    </div>
  );
}
